import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import { nativeAppVersion } from "./app-identity";

const FALLBACK_VERSION = "0.0.0";

const resolveAppVersion = (remoteVersion: string | undefined) =>
	(isWeb ? remoteVersion : nativeAppVersion) ?? FALLBACK_VERSION;

const getAppVersion = () =>
	resolveAppVersion(useAppStore.getState().app?.version);

const useAppVersion = () =>
	resolveAppVersion(useAppStore((state) => state.app?.version));

export { getAppVersion, useAppVersion };
